module.exports = __webpack_public_path__ + "img/Road-bike-right-side.eb1f0b5.svg";